import { TitleWrapper } from './title-display.styles';

const TitleDisplay = ({ section }) => {
  const {
    text,
    align,
    fontSize,
    fontSizeMobile,
    background,
    color,
    padding,
    paddingMobile,
    margin,
    marginMobile,
  } = section.content;

  return (
    <TitleWrapper
      align={align}
      fontSize={fontSize}
      fontSizeMobile={fontSizeMobile}
      background={background}
      color={color}
      padding={padding}
      paddingMobile={paddingMobile}
      margin={margin}
      marginMobile={marginMobile}
    >
      {text}
    </TitleWrapper>
  );
};

export default TitleDisplay;